import React from 'react';
import { useInput } from 'react-admin';
import { IpWhitelistInput } from './IpWhitelistInput';

interface IpWhitelistFieldInputProps {
    source: string;
    disabled?: boolean;
}

export const IpWhitelistFieldInput: React.FC<IpWhitelistFieldInputProps> = ({ source, disabled }) => {
    const {
        field,
    } = useInput({ source });

    // Parse the value if it's a string
    const value = React.useMemo(() => {
        if (typeof field.value === 'string') {
            try {
                return JSON.parse(field.value);
            } catch {
                return field.value;
            }
        }
        return field.value;
    }, [field.value]);

    const handleChange = (newValue: string[]) => {
        field.onChange(newValue);
    };

    return (
        <IpWhitelistInput
            value={value}
            onChange={handleChange}
            disabled={disabled}
        />
    );
};